import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import user from "./modules/user";
import role from "./modules/role";
import chat from "./modules/chat";
import layout from "./modules/layout";
import report from "./modules/report";
import subject from "./modules/subject";
import tag from "./modules/tag";
import visitor from "./modules/visitor";
import content from "./modules/content";
import setting from "./modules/setting";
import permission from "./modules/permission";
import welcomeMessage from "./modules/welcomeMessage";
import catalogCategory from "./modules/catalogCategory";
import catalogContent from "./modules/catalogContent";
import bannedWord from "./modules/bannedWord";
import adminUser from "./modules/adminUser";
import announcement from "./modules/announcement";
import site from "./modules/site";
import app from "./modules/app";
import language from "./modules/language";
import offlineSupportRequest from "./modules/offlineSupportRequest";
import socketStatus from "./modules/socketStatus";
import customLoginForm from "./modules/customLoginForm";
import catalog from "./modules/catalog";
import globalSettings from "./modules/globalSettings";
import ticket from "./modules/ticket";
import webrtc from "./modules/webrtc";
import whatsapp from "./modules/whatsapp";
import instagram from "./modules/instagram";
import telegrambot from "./modules/telegrambot";
import trigger from "./modules/trigger";
import CB from "./modules/CB";
import team from "./modules/team";
import customerWebhook from "./modules/customerWebhook";
import contactProperty from "./modules/contactProperty";
import channel from "./modules/channel";
import mail from "./modules/mail";
import calendar from "./modules/calendar";
import wallet from "./modules/wallet";
import tasks from "./modules/tasks";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        customerWebhook,
        tag,
        app,
        auth,
        team,
        user,
        role,
        chat,
        layout,
        report,
        subject,
        visitor,
        content,
        setting,
        permission,
        language,
        bannedWord,
        welcomeMessage,
        adminUser,
        site,
        offlineSupportRequest,
        socketStatus,
        customLoginForm,
        catalog,
        catalogCategory,
        catalogContent,
        globalSettings,
        ticket,
        webrtc,
        whatsapp,
        instagram,
        telegrambot,
        trigger,
        announcement,
        CB,
        contactProperty,
        channel,
        mail,
        wallet,
        calendar,
        tasks
    },
});

export default store;
